//// eAnmeldung KOSTEN

function preisupdate() {
    if (typeof preis !== 'undefined') {
      if (typeof preisgruppe !== 'undefined') {
  
        // var inputxx = $('.konf_radio input:checked');
        var name = $('.konf_radio input:checked').name;
        // var titel = inputxx.data('titel');
        // console.log('update' + titel);
        var inputxx = $('.konf_radio input[name="' + name + '"]:checked');
        preis = inputxx.data('pg' + preisgruppe);
        if (preis != null) {
          inputxx.val(preis);
          inputxx.data('preis', preis)
        }
      }
    }
  }
  
  
  // $(".konf_tage input").click(function () {
  $(".konf_tage input").on("click", function () {
    var name = this.name;
    var item_pg = document.querySelector('input[name="' + name + '"]:checked');
    var preisgruppe = $(item_pg).data('preisgruppe');
  
    $('.konf_radio label i').removeClass('preishigh');
    $('.konf_radio label i.pg' + preisgruppe).addClass('preishigh');
    $('.konf_radio label i.pg').addClass('preishigh');
  
    $(".konf_radio input").each(function () {
      var preis = $(this).data('pg' + preisgruppe);
      var flex_titel = $(this).data('titel').replace(/(.*[^*])(\s\**$)/i, "$1").replace(/\//ig, "");
      if (preis != null) {
        // $(this).val(ding);
        $(this).data('preis', preis)
        $(this).val(flex_titel + ' ' + preis + '€');
      }
    });
    preisupdate();
  });
  
  
  // $(".konf_radio input").click(function () {
  $(".konf_radio input").on("click", function () {
    // console.log(preisgruppe);
    //var clicked_name = this.name;
    //var clicked_item = document.querySelector('input[name="' + clicked_name + '"]:checked');
  
    // console.log(this.name);
    // var flex = $('.konf_radio input:checked');
  
    var flex_titel1 = $(this).data('titel').replace(/(.*[^*])(\s\**$)/i, "$1").replace(/\//ig, "");
    var flex_preis = $(this).data('preis');
    // var value = flex.val();
    var titelvalue = flex_titel1 + ' ' + flex_preis + '€';
    $(this).val(titelvalue);
    // console.log(titelvalue);
  
    if (typeof preisgruppe !== 'undefined') {
      preis = $(this).data('pg' + preisgruppe);
      var flex_titel2 = $(this).data('titel').replace(/(.*[^*])(\**$)/i, "$1").replace(/(<([^>]+)>)/ig, "").replace(/\//ig, "");
      // console.log(flex_titel);
      if (preis != null) {
        // $(this).val(preis);
        $(this).data('preis', preis);
        $(this).val(flex_titel2 + ' ' + preis + '€');
      }
    }
    preisupdate();
  });
  
  
  
  var $inputs = $('.bedingte_form input');
  $inputs.on('change', function () {
  
    var sum = 0;
    $inputs.each(function () {
      if (this.checked && $(this).hasClass('konf_sum')) {
        if (this.value === "on") {
          var betrag = 0;
        } else {
          var betrag = this.value.replace(/(.*(?:\:)?\s)([\d]+)(\€)/i, "$2");
        }
        sum += parseInt(betrag);
      }
    });
    $("output#betrag").val(sum);
    $("input#ea_summe").val(sum);
  });